import { render, staticRenderFns } from "./oc-footer.vue?vue&type=template&id=cd1514fe"
import script from "./oc-footer.vue?vue&type=script&lang=js"
export * from "./oc-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports